import Signature from './Signature/index'

export default {
  install(Vue) {
    Vue.component('Signature-vue', Signature)
  }
}